{
  "list": {
    "heading": "Ward",
    "loading": "Loading the ward list …",
    "failed": "The ward list could not be loaded.",
    "retry": "Try again",
    "notFound": "No such ward in the record.",
    "empty": "No patients are admitted to this ward.",
    "caption": "Patients on the ward, one row per bed.",
    "occupancy": "{occupied} of {total} beds occupied{withoutBed, plural, =0 {} other { · # without a bed}}",
    "occupancyWithoutTotal": "{occupied, plural, =0 {No patients admitted} one {# patient admitted} other {# patients admitted}}"
  },
  "column": {
    "bed": "Bed",
    "name": "Name",
    "identifier": "Personnummer / reservnummer",
    "age": "Age",
    "admitted": "Admitted",
    "responsible": "Responsible physician",
    "safety": "Alerts"
  },
  "picker": {
    "label": "Show ward"
  },
  "patient": {
    "responsibleNotDocumented": "Not documented"
  }
}
